import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_player-skip-forward",
  "use": "icon_player-skip-forward-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon_player-skip-forward\"><path stroke=\"currentColor\" stroke-linecap=\"square\" d=\"M19 4v16M5 4l10 8-10 8V4Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol